module.exports = __webpack_public_path__ + "img/2.9b498f81.jpg";